import React from "react";
import PropTypes from "prop-types";
import "../assets/_variables.scss";

const Popup = ({
  isOpen,
  onClose,
  onAction,
  title,
  text,
  link,
  linkText,
  icon,
  closeButtonText ,
  actionButtonText,
  color,
}) => {
  if (!isOpen) return null;

  // Determine button classes based on color prop
  const closeBtnClass =
    color === "blue" ? "popup-close-btn" : "popup-close-btn";
  const actionBtnClass = color === "blue" ? "btn-primary" : "popup-action-btn";

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">{icon}</div>
        <h3 className="popup-title">{title}</h3>
        <p className="popup-text">
          {text}
          {link && (
            <a
              href={link}
              className="popup-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkText}
            </a>
          )}
        </p>
        <div className="popup-actions">
          {closeButtonText&& (
            <button className={closeBtnClass} onClick={onClose}>
            {closeButtonText}
          </button>
          )}
          {actionButtonText && (
            <button className={actionBtnClass} onClick={onAction}>
              {actionButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Optional: Prop type validation
Popup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
  linkText: PropTypes.string,
  icon: PropTypes.element,
  closeButtonText: PropTypes.string,
  actionButtonText: PropTypes.string,
  color: PropTypes.oneOf(["blue", "red"]),
};

export default Popup;
